import {
  createDedupeId,
  getApplovinLanding,
  waitForAxwrtCookie,
} from '@openeducation/pp-js-utils';
import { PPApiService } from '@openeducation/pp-rn-services';
import type { InvoiceCardProps } from '@openeducation/pp-rn-shared-types';

import { useEnvironmentContext } from '../../../environment/environment.provider';
import { useGoogleTagManager } from '../../../hooks';

interface TrackBeginCheckoutParams {
  sfdcToken: string;
  leadServiceId?: string;
  invoiceCardProps: InvoiceCardProps;
  email?: string;
  userId?: string;
}

// Sends begin_checkout to the dataLayer. When the checkout comes from an
// AppLovin click (aleid or alart), it also sends it to AG for the AppLovin
// Conversion API, with the same dedupe_id.
export const useTrackBeginCheckout = () => {
  const { environment } = useEnvironmentContext();
  const { pushEventCheckoutStarted } = useGoogleTagManager();

  const trackBeginCheckout = async ({
    sfdcToken,
    leadServiceId,
    invoiceCardProps,
    email,
    userId,
  }: TrackBeginCheckoutParams) => {
    // A new dedupe_id on each page load. Many begin_checkout events for the
    // same payment link are OK.
    const dedupeId = createDedupeId();
    pushEventCheckoutStarted(leadServiceId, invoiceCardProps, {
      dedupeId,
      email,
      userId,
    });

    const landing = getApplovinLanding(sfdcToken);
    if (!landing) {
      return;
    }

    try {
      const axwrt = await waitForAxwrtCookie();
      await PPApiService.trackBeginCheckout(environment, {
        sfdcToken,
        dedupeId,
        ...landing,
        ...(axwrt ? { axwrt } : {}),
      });
    } catch {
      // A tracking error must not stop the checkout.
    }
  };

  return { trackBeginCheckout };
};
